import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import InputMask from 'react-input-mask';

import { UserContext } from '../../../context/UserContext';
import StepButtons from '../../common/StepButtons';

/** services */
import { postCompletion } from '../../../service/api';
import { mobileNumberPattern } from '../../../constants/fields';

import iconCall from '../../../assets/images/icons/icon-call.svg';
import iconMail from '../../../assets/images/icons/icon-mail.svg';

const UnlockMasterCard = ({ handleGotoPrev, handleGotoNext, validateMaskInput, validateEmail }) => {
  const history = useHistory();
  const { width, hasAdditionalStep, formData, directors, updateContext } = useContext(UserContext);
  const [pageError, setPageError] = useState('');
  const [ids, setIds] = useState(directors.map((d, i) => i));
  const [data, setData] = useState(
    directors && directors.length
      ? new Array(directors.length).fill({
          mobile: hasAdditionalStep ? formData.mobileNumber : '',
          email: hasAdditionalStep ? formData.emailAddress : '',
        })
      : []
  );
  const [payment_terms, setPaymentTerms] = useState('');
  // const [extraOption, setExtraOption] = useState(false);
  // const paymentTermsOptions = ['30 days', '60 days'];

  const [dataError, setDataError] = useState(
    new Array(directors.length).fill({
      mobile: '',
      email: '',
    })
  );

  const handleContinue = async () => {
    updateContext({ error: '' });
    setDataError(
      new Array(directors.length).fill({
        mobile: '',
        email: '',
      })
    );
    const directorsData = data
      .map((d, i) => {
        return { ...d, director_index: i };
      })
      .filter((d, i) => {
        return ids.includes(i);
      });
    if (ids.length) {
      let isInValid = true;
      directorsData.map((director) => {
        const valid1 = validateInput(director['mobile'], 'mobile', director.director_index);
        const valid2 = validateInput(director['email'], 'email', director.director_index);
        if (!valid1 || !valid2) isInValid = false;
      });

      if (!isInValid) {
        setPageError('You need to select directors and fill in the values');
        return;
      }
      // if (!payment_terms) {
      //   setPageError('You need to select one payment terms.');
      //   return;
      // }
    } else {
      setPageError('At least one UnLock Mastercard holder must be selected');
      return;
    }

    updateContext({ loading: true });
    try {
      console.log(directorsData);
      const params = /* !extraOption
        ? */ {
        directors: directorsData.map((director) => {
          return {
            ...director,
            mobile: director.mobile.replaceAll('-', ''),
          };
        }),
        payment_terms,
      };
      // : {};
      // const res = await bankStatement(params);
      const res = await postCompletion(params);
      if (res && res.data) {
        updateContext({ token: res.data.Token, content: res.data.Content });
      }
      updateContext({ loading: false });
      history.push('/success');
      handleGotoNext();
    } catch (error) {
      if (error.response.data && error.response.data.error) {
        updateContext({ error: error.response.data.error });
        history.push('/error');
      }
    }

    updateContext({ loading: false });
  };

  // Checks form field input validation
  const validateInput = (value, name, index) => {
    // Skip validation for disabled fields
    if ((name === 'mobile' || name === 'email') && (!ids.includes(index) || hasAdditionalStep)) {
      setDataError((dataError) =>
        dataError.map((de, i) => {
          return i == index
            ? {
                ...de,
                [name]: '',
              }
            : de;
        })
      );
      return true;
    }
    if (!value || value == '') {
      setDataError((dataError) =>
        dataError.map((de, i) => {
          return i == index
            ? {
                ...de,
                [name]: 'This is a required field',
              }
            : de;
        })
      );

      return false;
    }
    if (name === 'mobile') {
      const maskInputValid = validateMaskInput(value, mobileNumberPattern);
      if (!maskInputValid) {
        setDataError((dataError) =>
          dataError.map((de, i) => {
            return i == index
              ? {
                  ...de,
                  [name]: 'Format is incorrect',
                }
              : de;
          })
        );
        return false;
      }
      setDataError((dataError) =>
        dataError.map((de, i) => {
          return i == index
            ? {
                ...de,
                [name]: '',
              }
            : de;
        })
      );
      setPageError('');
      return true;
    }
    if (name === 'email') {
      const emailValid = validateEmail(value);
      if (!emailValid) {
        setDataError((dataError) =>
          dataError.map((de, i) => {
            return i == index
              ? {
                  ...de,
                  [name]: 'Invalid email address',
                }
              : de;
          })
        );
        return false;
      }
      setDataError((dataError) =>
        dataError.map((de, i) => {
          return i == index
            ? {
                ...de,
                [name]: '',
              }
            : de;
        })
      );
      setPageError('');
      return true;
    }
    setDataError((dataError) =>
      dataError.map((de, i) => {
        return i == index
          ? {
              ...de,
              [name]: '',
            }
          : de;
      })
    );
    setPageError('');
    return true;
  };

  // Handler for form field change
  const handleChange = (e, index) => {
    setData(
      data.map((d, i) => {
        return i == index
          ? {
              ...d,
              [e.target.name]: e.target.value,
            }
          : d;
      })
    );
  };

  const handlePhoneChange = (e, index) => {
    const inputValue = e.target.value;
    // Check that the entered characters correspond to the beginning of the current value and do not delete the prefix
    if (inputValue.startsWith('+61')) {
      setData((prevData) => {
        if (Array.isArray(prevData)) {
          return [
            ...prevData.slice(0, index),
            { ...prevData[index], mobile: inputValue },
            ...prevData.slice(index + 1),
          ];
        } else {
          return {
            ...prevData,
            [index]: {
              ...prevData[index],
              mobile: inputValue,
            },
          };
        }
      });
      validateInput(inputValue, 'mobile', index);
    } else {
      // If the user deleted +61, start printing again
      setData((prevData) => {
        if (Array.isArray(prevData)) {
          return [
            ...prevData.slice(0, index),
            { ...prevData[index], mobile: '+61' },
            ...prevData.slice(index + 1),
          ];
        } else {
          return {
            ...prevData,
            [index]: {
              ...prevData[index],
              mobile: '+61',
            },
          };
        }
      });
    }
  };

  const handleChangeOption = (e) => {
    setPaymentTerms(e.target.value);
  };
  /*
  const handleChangeExtraOption = (e) => {
    if (e.target.checked) {
      setPaymentTerms('');
      setIds([]);
    }
    setExtraOption(e.target.checked);
  };
*/
  const handleSelectDirectors = (e) => {
    setPageError('');
    if (!ids.includes(Number(e.target.value))) {
      // setExtraOption(false);
      setIds([...ids, Number(e.target.value)]);
    } else {
      setIds(ids.filter((id) => id !== Number(e.target.value)));
      if (ids.length > 0) {
        setPageError('');
      }

      setDataError(
        dataError.map((d, i) => {
          return i == e.target.value
            ? {
                mobile: '',
                email: '',
              }
            : d;
        })
      );
      setData(
        data.map((d, i) => {
          return i == e.target.value
            ? {
                mobile: '',
                email: '',
              }
            : d;
        })
      );
    }
  };

  return (
    <div className="custom-steps custom-steps-custom select-director">
      
      <div className='custom-navigation-block-two navigation-custom'>
        <span>APPROVAL</span>
      </div>

      <div className='select-director-custom'>

      <div className="custom-master-cart-header">
        <p>Who will receive an</p>
        <span className="custom-mastercard-r-v2">UnLock Mastercard</span>
      </div>


      <div className="search-results search-results-custom">
        {directors.map((row, index) => {
          return (
            <div key={index} className="company-info unlock-card">
              <div className="row-name-browser-view" style={{ padding: '10px 0' }}>
                <div className='flex items-center'>
                  <div className='flex-none w-15'>
                    <input
                      id={index}
                      name={'selectedDirector'}
                      type="checkbox"
                      value={index}
                      disabled={hasAdditionalStep}
                      checked={ids.includes(index)}
                      onChange={handleSelectDirectors}
                      style={{margin: '5px'}}
                    />
                  </div>
                  <div className='flex-auto'>
                    <span className="name">{row.Name}</span>
                  </div>
                </div>
                <div className="desktop-inputs">
                  <div>
                    <div className='input-block'>
                      {/* custom icon  */}
                      <div className="icon-input-image">
                        <img src={iconCall} alt="icon-image"/>
                      </div>
                      <InputMask
                        id={index}
                        name={'mobile'}
                        mask={'+99-999-999-999'}
                        disabled={!ids.includes(index) || hasAdditionalStep}
                        value={(Array.isArray(data) ? data[index]?.mobile : data?.mobile) || '+61'}
                        onChange={(e) => { handlePhoneChange(e, index) }}
                        onBlur={() => validateInput(Array.isArray(data) ? data[index]?.mobile : data?.mobile, 'mobile', index)}
                        placeholder={'Mobile No'}
                        className="phone-input"
                      />
                    </div>
                    {dataError[index]['mobile'] && <p className="error-text error-text-two">{dataError[index]['mobile']}</p>}
                  </div>
                  <div>
                    <div className='input-block'>
                      <div className="icon-input-image">
                        <img src={iconMail} alt="icon-image"/>
                      </div>
                      <input
                        id={index}
                        value={data[index]['email']}
                        name={'email'}
                        autoComplete="off"
                        disabled={!ids.includes(index) || hasAdditionalStep}
                        onChange={(e) => handleChange(e, index)}
                        onBlur={(e) => validateInput(data[index]['email'], 'email', index)}
                        className="email-input"
                        placeholder="Email"
                      />
                    </div>
                    {dataError[index]['email'] && <p className="error-text error-text-two">{dataError[index]['email']}</p>}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        {/*<h3 className="text" dangerouslySetInnerHTML={{ __html: content }}></h3>*/}
        {/*

        {paymentTermsOptions.map((option, index) => {
          return (
            <div key={'option' + index} className="company-info">
              <span className="name">{option}</span>
              <input
                id={'option' + index}
                name={'payment_terms'}
                disabled={ids.length === 0}
                type="radio"
                value={option}
                checked={option === payment_terms}
                onChange={handleChangeOption}
              />
            </div>
          );
        })}

*/}
        {/*  */}
        {/*<div className="company-info">*/}
        {/*  <span className="name">I don't want to receive an UnLock Mastercard at this stage</span>*/}
        {/*  <input*/}
        {/*    id={'extra-option'}*/}
        {/*    name={'extraOption'}*/}
        {/*    type="checkbox"*/}
        {/*    checked={extraOption}*/}
        {/*    onChange={handleChangeExtraOption}*/}
        {/*  />*/}
        {/*</div>*/}
        {/*  */}
        <div className="unlock-card-info">
          <span>You can also add more card holders through the UnLock Portal.</span>
        </div>
      </div>
      {pageError && <p className="error-section error-text-mod-two">{pageError}</p>}
      <div className='unlock-master-card-button'>
        <StepButtons
          handleGotoPrev={handleGotoPrev}
          handleGotoNext={handleContinue}
          // isNextDisabled={!extraOption && ids.length === 0}
          // isNextDisabled={ids.length === 0}
        />
      </div>
      </div>
    </div>
  );
};

export default UnlockMasterCard;
